export function useDataLoading({
  getterName, searchable = true, paged = true,
  parameterize = false, contentName = '', dataParams = [],
}) {
  return {
    data() {
      return {
        isLoading: false,
        loadingError: { show: false, text: '' },
        allowGettingData: true,
      };
    },
    computed: {
      noContent() {
        return {
          show: contentName ? this[contentName].length < 1 : false,
          text: 'No content',
        };
      },
    },
    watch: {
      allowGettingData: {
        handler(newValue) {
          if (!newValue) {
            return;
          }
          this.$nextTick(async () => {
            try {
              await this.getData();
            } finally {
              this.allowGettingData = false;
            }
          });
        },
        immediate: true,
      },
      '$route.params': {
        handler() {
          if (parameterize) {
            this.$_fetchData();
          }
        },
        deep: true,
      },
      '$route.query': {
        handler() {
          this.$_fetchData();
        },
        deep: true,
      },
    },
    methods: {
      async getData() {
        const response = { ...this.$route.query };

        if (searchable) {
          Object.assign(response, {
            ...response,
            ...this.parseSearchData(this.searchData),
          });
        }

        if (parameterize) {
          Object.assign(response, {
            ...response,
            ...this.$route.params,
          });
        }

        if (paged) {
          response.pageNum = response.pageNum || '1';
        }

        dataParams.forEach((param) => {
          response[param] = this[param];
        });

        this.$_showLoading();
        this.$_setLoadingError({ show: false });

        try {
          await this[getterName](response);
          return Promise.resolve();
        } catch (e) {
          this.$_setLoadingError({ text: e });
          return Promise.reject();
        } finally {
          this.$_hideLoading();
        }
      },
      $_fetchData() {
        this.allowGettingData = true;
      },
      $_refreshData() {
        if (this.pageNum && Number(this.pageNum) !== 1 && !this.$_resetSearch) {
          this.$_setPage('1');
        }
        if (this.$_resetSearch) {
          this.$_resetSearch();
        }
        setImmediate(this.$_fetchData);
      },
      $_showLoading() {
        this.isLoading = true;
      },
      $_hideLoading() {
        this.isLoading = false;
      },
      $_setLoadingError({ show = true, text = '' }) {
        Object.assign(this, { loadingError: { show, text } });
      },
    },
  };
}

export default {};
